"use client";
import { mapModifiers } from "@/utils/funtion";
import Image from "next/image";
import service1 from "@/assets/images/service/0001.jpg";
import service2 from "@/assets/images/service/0002.jpg";
import service3 from "@/assets/images/service/0003.jpg";
import service4 from "@/assets/images/service/0004.jpg";
import service5 from "@/assets/images/service/0005.jpg";
import serviceI1 from "@/assets/images/service/service-icon-01.png";
import serviceI2 from "@/assets/images/service/service-icon-02.png";
import serviceI3 from "@/assets/images/service/service-icon-03.png";
import serviceI4 from "@/assets/images/service/service-icon-05.png";
import serviceI5 from "@/assets/images/service/service-icon-06.png";
import React, { useEffect, useState } from 'react';
import { FiCheckCircle } from "react-icons/fi";
import { IoStatsChartSharp } from "react-icons/io5";
import Skeleton from "@/components/atoms/skeletons";
import Tabs from "@/components/atoms/tabs";
import { useSearchParams } from "next/navigation";

const ServiceModule = () => {
    const [activeTab, setActiveTab] = useState("1")
    const [loading, setLoading] = useState(true)
    const searchParams = useSearchParams();
    const tabName = searchParams?.get("tab");

    useEffect(() => {
        if (tabName) {
            switch (tabName) {
                case "du-lieu-kinh-te-va-thi-truong":
                    setActiveTab("1")
                    break;
                case "phan-tich-chuyen-sau":
                    setActiveTab("2")
                    break;
                case "khao-sat":
                    setActiveTab("3")
                    break;
                case "nghien-cuu-chinh-sach":
                    setActiveTab("4")
                    break;
                case "tu-van-giai-phap":
                    setActiveTab("5")
                    break;
                default:
                    setActiveTab("1")
            }
        }
        setTimeout(() => {
            setLoading(false)
        }, 900);
    }, [tabName]);
    
    const onChange = (key: string) => {
        setActiveTab(key);
    };

    const items = [
        {
            key: '1',
            label: <ServiceTabItem name='Dữ liệu kinh tế và thị trường' icon={serviceI1} />,
            children: <ServicePanelItem title="Cung cấp dữ liệu kinh tế và thị trường" serverNumber={1} />,
        },
        {
            key: '2',
            label: <ServiceTabItem name='Phân tích chuyên sâu' icon={serviceI2} />,
            children: <ServicePanelItem title="Thực hiện các báo cáo tư vấn và phân tích chuyên sâu" serverNumber={2} />,
        },
        {
            key: '3',
            label: <ServiceTabItem name='Khảo sát theo nhu cầu' icon={serviceI3} />,
            children: <ServicePanelItem title="Thực hiện các báo cáo tư vấn và phân tích chuyên sâu" serverNumber={3} />,
        },
        {
            key: '4',
            label: <ServiceTabItem name='Nghiên cứu chính sách' icon={serviceI4} />,
            children: <ServicePanelItem title="Nghiên cứu và tư vấn chính sách và đánh giá tác động chính sách" serverNumber={4} />,
        },
        {
            key: '5',
            label: <ServiceTabItem name='Tư vấn giải pháp' icon={serviceI5} />,
            children: <ServicePanelItem title="Tư vấn giải pháp cho phát triển bền vững" serverNumber={5} />,
        },
    ];
    return (
        <div className={mapModifiers("service-module")}>
            <div className={mapModifiers("service-module-wrapper")}>
                {loading ? (
                    <Skeleton type="default" />
                ) : (
                    <>
                        <div className="service-title page-title">
                            Dịch vụ và giải pháp của chúng tôi
                        </div>
                        <div className="all-service">
                            <Tabs activeKey={activeTab} items={items} onChange={onChange} />
                        </div>
                    </>
                )}

            </div>
        </div>
    );
};

export default ServiceModule;

const ServiceTabItem = ({ icon, name }: { icon: any, name: string }) => {
    return (
        <div className={mapModifiers("service-tab-item")}>
             <Image  src={icon} alt="tab" loading="lazy"/>
            <div className="service-name">
                {name}
            </div>
        </div>
    );
};

const ServicePanelItem = ({ title, serverNumber }: { title: string, serverNumber: number }) => {
    const renderServiceContent = () => {
        switch (serverNumber) {
            case 1:
                return <ServiceContent1 />;
            case 2:
                return <ServiceContent2 />;
            case 3:
                return <ServiceContent3 />;
            case 4:
                return <ServiceContent4 />;
            case 5:
                return <ServiceContent5 />;
            default:
                return null;
        }
    };
    return (
        <div className={mapModifiers("service-panel-item")}>
            <div className="service-panel-item-title">
                {title}
            </div>
            <div className="service-panel-item-content">
                {renderServiceContent()}
            </div>
        </div>
    );
};

const ServiceContent1 = () => {
    return (
        <div className="service-content">
            <div className="service-content-left">
                <ul className="service-list">
                    <li className="service-list-item"><div className="service-list-icon"><FiCheckCircle /></div> Dữ liệu kinh tế vĩ mô</li>
                    <li className="service-list-item"><div className="service-list-icon"><FiCheckCircle /></div> Dữ liệu các ngành kinh tế</li>
                    <li className="service-list-item"><div className="service-list-icon"><FiCheckCircle /></div> Dữ liệu tài chính</li>
                    <li className="service-list-item"><div className="service-list-icon"><FiCheckCircle /></div> Dữ liệu kinh tế địa phương</li>
                    <li className="service-list-item"><div className="service-list-icon"><FiCheckCircle /></div> Dữ liệu thị trường:</li>
                    <ul className="service-sub-list">
                        <li className="service-sub-item"><IoStatsChartSharp />Bất động sản</li>
                        <li className="service-sub-item"><IoStatsChartSharp />Ngân hàng</li>
                        <li className="service-sub-item"><IoStatsChartSharp />Chứng khoản </li>
                        <li className="service-sub-item"><IoStatsChartSharp />Bảo hiểm</li>
                        <li className="service-sub-item"><IoStatsChartSharp />Tỷ giá hối đoái</li>
                        <li className="service-sub-item"><IoStatsChartSharp />Tiền điện tử</li>
                        <li className="service-sub-item"><IoStatsChartSharp />Hàng hóa cơ bản</li>
                    </ul>
                    <li className="service-list-item"><div className="service-list-icon"><FiCheckCircle /></div> Dữ liệu lao động-việc làm</li>
                    <li className="service-list-item"><div className="service-list-icon"><FiCheckCircle /></div> Dữ liệu về điều tra doanh nghiệp</li>
                    <li className="service-list-item"><div className="service-list-icon"><FiCheckCircle /></div> Dữ liệu hộ gia đình</li>
                </ul>
            </div>
            <div className="service-content-right">
                 <Image  src={service1} alt="service1" loading="lazy"/>
            </div>
        </div>
    );
};

const ServiceContent2 = () => {
    return (
        <div className="service-content">
            <div className="service-content-left">
                <ul className="service-list">
                    <li className="service-list-item"><div className="service-list-icon"><FiCheckCircle /></div> Báo cáo cập nhật kinh tế vĩ mô</li>
                    <li className="service-list-item"><div className="service-list-icon"><FiCheckCircle /></div> Báo cáo phân tích tác động chính sách vĩ mô</li>
                    <li className="service-list-item"><div className="service-list-icon"><FiCheckCircle /></div> Báo cáo ngành kinh tế</li>
                    <li className="service-list-item"><div className="service-list-icon"><FiCheckCircle /></div> Báo cáo kinh tế địa phương</li>
                    <li className="service-list-item"><div className="service-list-icon"><FiCheckCircle /></div> Báo cáo xu hướng các thị trường:</li>
                    <ul className="service-sub-list">
                        <li className="service-sub-item"><IoStatsChartSharp />Bất động sản</li>
                        <li className="service-sub-item"><IoStatsChartSharp />Ngân hàng</li>
                        <li className="service-sub-item"><IoStatsChartSharp />Chứng khoản </li>
                        <li className="service-sub-item"><IoStatsChartSharp />Nông nghiệp</li>
                        <li className="service-sub-item"><IoStatsChartSharp />Công nghiệp</li>
                        <li className="service-sub-item"><IoStatsChartSharp />Dịch vụ</li>
                    </ul>
                    <li className="service-list-item"><div className="service-list-icon"><FiCheckCircle /></div> Nghiên cứu tác động chính sách:</li>
                    <ul className="service-sub-list">
                        <li className="service-sub-item"><IoStatsChartSharp />Chính sách tài khóa</li>
                        <li className="service-sub-item"><IoStatsChartSharp />Chính sách tiền tệ</li>
                        <li className="service-sub-item"><IoStatsChartSharp />Chính sách tỷ giá</li>
                        <li className="service-sub-item"><IoStatsChartSharp />Chính sách ngoại thương</li>
                        <li className="service-sub-item"><IoStatsChartSharp />Chính sách cơ cấu</li>
                    </ul>
                </ul>
            </div>
            <div className="service-content-right">
                 <Image  src={service4} alt="service2" loading="lazy"/>
            </div>
        </div>
    );
};

const ServiceContent3 = () => {
    return (
        <div className="service-content">
            <div className="service-content-left">
                <ul className="service-list">
                    <li className="service-list-item"><div className="service-list-icon"><FiCheckCircle /></div> Điều tra xu hướng thị trường</li>
                    <li className="service-list-item"><div className="service-list-icon"><FiCheckCircle /></div> Khảo sát hành vi người tiêu dùng</li>
                    <li className="service-list-item"><div className="service-list-icon"><FiCheckCircle /></div> Khảo sát môi trường kinh doanh phục vụ quyết định đầu tư</li>
                    <li className="service-list-item"><div className="service-list-icon"><FiCheckCircle /></div> Nghiên cứu tác động chính sách đến doanh nghiệp</li>
                </ul>
            </div>
            <div className="service-content-right">
                 <Image  src={service3} alt="service3" loading="lazy"/>
            </div>
        </div>
    );
};

const ServiceContent4 = () => {
    return (
        <div className="service-content">
            <div className="service-content-left">
                <ul className="service-list">
                    <li className="service-list-item"><div className="service-list-icon"><FiCheckCircle /></div> Tư vấn giải pháp quản trị rủi ro và thích ứng với chính sách kinh tế vĩ mô</li>
                    <li className="service-list-item"><div className="service-list-icon"><FiCheckCircle /></div> Đánh giá tác động chính sách của Chính phủ đến ngành và doanh nghiệp</li>
                    <li className="service-list-item"><div className="service-list-icon"><FiCheckCircle /></div> Chính sách ứng phó và nâng cao khả năng chống chịu của DN trước các thách thức vĩ mô</li>
                    <li className="service-list-item"><div className="service-list-icon"><FiCheckCircle /></div> Tư vấn chính sách thúc đẩy phát triển kinh tế ngành</li>
                    <li className="service-list-item"><div className="service-list-icon"><FiCheckCircle /></div> Tư vấn phát triển kinh tế địa phương</li>
                    <li className="service-list-item"><div className="service-list-icon"><FiCheckCircle /></div> Lập quy hoạch chiến lược phát triển các ngành kinh tế: nông nghiệp, công nghiệp chế biến chế tạo, thương mại, du lịch…</li>
                    <li className="service-list-item"><div className="service-list-icon"><FiCheckCircle /></div> Đánh giá lợi thế cạnh tranh của các ngành, địa phương cho chiến lược đầu tư của DN</li>
                    <li className="service-list-item"><div className="service-list-icon"><FiCheckCircle /></div> Nghiên cứu và tư vấn chính sách tái cấu trúc và nâng cao năng lực cạnh tranh của các địa phương, các ngành kinh tế</li>
                    <li className="service-list-item"><div className="service-list-icon"><FiCheckCircle /></div> Nghiên cứu và tư vấn chiến lược phát triển kinh tế địa phương, chiến lược phát triển các ngành kinh tế</li>
                    <li className="service-list-item"><div className="service-list-icon"><FiCheckCircle /></div> Đào tạo nhân lực phân tích chính sách và kinh tế</li>
                </ul>
            </div>
            <div className="service-content-right">
                 <Image  src={service2} alt="service4" loading="lazy"/>
            </div>
        </div>
    );
};

const ServiceContent5 = () => {
    return (
        <div className="service-content">
            <div className="service-content-left">
                <ul className="service-list">
                    <li className="service-list-item"><div className="service-list-icon"><FiCheckCircle /></div> Tư vấn tái cấu trúc và hoạch định chiến lược phát triển bền vững cho doanh nghiệp</li>
                    <li className="service-list-item"><div className="service-list-icon"><FiCheckCircle /></div> Tư vấn chiến lược giảm phát thải GHG với chi phí và lộ trình tối ưu, xây dựng tầm nhìn “Net Zero” cho doanh nghiệp</li>
                    <li className="service-list-item"><div className="service-list-icon"><FiCheckCircle /></div> Tư vấn giải pháp và lập báo cáo ESG</li>
                    <li className="service-list-item"><div className="service-list-icon"><FiCheckCircle /></div> Tư vấn chuyển đổi số tích hợp</li>
                    <li className="service-list-item"><div className="service-list-icon"><FiCheckCircle /></div> Tư vấn giải pháp chuyển đổi xanh, phát triển bền vững</li>
                </ul>
            </div>
            <div className="service-content-right">
                 <Image  src={service5} alt="service5" loading="lazy"/>
            </div>
        </div>
    );
};